import React, { useState } from "react";
import { Anchor } from "antd";
import styled from "styled-components";

import SidebarItem from "./sidebarItem";

const StyledAnchor = styled(Anchor)`
  .ant-anchor-ink {
    display: none;
  }
`;

const StyledAnchorDisabled = ({ children, ...props }) => (
  <StyledAnchor onClick={(event) => event.preventDefault()} {...props}>
    {children}
  </StyledAnchor>
);

export default function Sidebar({
  sectionsWithErrors,
  sidebarItems,
  activeFormSection,
  formId,
  disabled,
  // The element the anchor scrolls. Defaults to the form itself, which is right
  // whenever the form is its own scroll container. A caller that renders the
  // sections inside a different scroller — the agentic review's application
  // window, where they sit in a modal body — passes that element instead, or the
  // anchor measures against a node the sections aren't in and clicking does
  // nothing.
  getContainer
}) {
  const [activeSection, setActiveSection] = useState(activeFormSection);
  const AnchorComponent = disabled ? StyledAnchorDisabled : StyledAnchor;
  return (
    <AnchorComponent
      onChange={(activeHref) => setActiveSection(activeHref)}
      getContainer={getContainer || (() => document.getElementById(formId))}
    >
      {sidebarItems.map(({ href, title, key, icon }) => (
        <SidebarItem
          key={key}
          href={href}
          title={title}
          icon={icon}
          isActive={activeSection === href}
          isCompleted={!sectionsWithErrors.includes(key)}
        />
      ))}
    </AnchorComponent>
  );
}
